export default __webpack_public_path__ + "static/media/lock.303b11e3.svg";